
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[slug]",
      function () {
        return require("private-next-pages/user/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[slug]"])
      });
    }
  